export default __webpack_public_path__ + "static/media/ai.050b8488.png";